import React from 'react';

import ProductCategoryCard from './ProductCategoryCard';
import { ProcurementManagerCategory } from '../../codegen/graphql';

type Props = {
    categories: ProcurementManagerCategory[];
};

function ProductCategories({ categories }: Props) {
    return categories.length ? (
        <div className="flex flex-col gap-2 mt-2">
            {categories.map(category => (
                <ProductCategoryCard
                    key={`${category.id}`}
                    category={category}
                />
            ))}
        </div>
    ) : (
        <div className="flex items-center justify-center h-12">
            <p className="font-medium">No Product Categories Found</p>
        </div>
    );
}

export default ProductCategories;
